import React, { useState, useCallback, useRef, useEffect } from 'react'
import Sidebar from './sidebar'
import Navbar from './navbar'
import Footer from './footer'

export default function Layout({ children }) {
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
    const [isMenuExpanded, setIsMenuExpanded] = useState(false);
    const [isMenuHovered, setIsMenuHovered] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleMenu = useCallback(() => {
        setIsMenuCollapsed(prev => !prev)
        setIsMenuExpanded(false)  // Remove expanded class when toggling
    }, [])

    const expandMenu = useCallback(() => {
        setIsMenuExpanded(true)
        setIsMenuCollapsed(false)  // Ensure menu is not collapsed when expanding
    }, [])

    const handleMouseEnter = useCallback(() => {
        setIsMenuHovered(true)
    }, [])

    const handleMouseLeave = useCallback(() => {
        setIsMenuHovered(false)
    }, [])

    const toggleDropdown = useCallback(() => {
        setIsDropdownOpen(prev => !prev);
    }, [])

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const layoutClasses = [
        "light-style",
        "layout-navbar-fixed",
        "layout-compact",
        "layout-menu-fixed",
        isMenuCollapsed && "layout-menu-collapsed",
        isMenuExpanded && "layout-menu-expanded",
        isMenuHovered && "layout-menu-hover"
    ].filter(Boolean).join(" ")

    return (
        <div className={layoutClasses} onClick={() => setIsDropdownOpen(false)}>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    {/* Sidebar */}
                    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <Sidebar toggleMenu={toggleMenu} />
                    </div>
                    {/* Sidebar */}

                    {/* Layout container */}
                    <div className="layout-page">
                        {/* Navbar */}
                        <Navbar 
                            expandMenu={expandMenu} 
                            isDropdownOpen={isDropdownOpen} 
                            toggleDropdown={toggleDropdown}
                            dropdownRef={dropdownRef}
                        />
                        {/* / Navbar */}
                        {/* Content wrapper */}
                        <div className="content-wrapper">
                            {/* Content */}
                            <div className="container-xxl flex-grow-1 container-p-y mt-10">
                                {children}
                            </div>
                            {/* / Content */}

                            {/* Footer */}
                            <Footer />
                            {/* / Footer */}

                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                    {/* / Layout page */}
                </div>
                {/* Overlay */}
                <div className="layout-overlay layout-menu-toggle" />
                {/* Drag Target Area To SlideIn Menu On Small Screens */}
                <div className="drag-target" />
            </div>
        </div>
    )
}